require('./hireAdvInterstitialPromotionSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @ helpers
const { formatText } = require('core/i18n').i18n;


class HireAdvInterstitialPromotionSuccess extends React.Component {

    render() {
        const { immAdvancedInterstitialPromotions } = this.props;
        const immPromotions = immAdvancedInterstitialPromotions.get('promotions');
        const promotionDetail = (<HTMLSafeInjector
            message={immPromotions.get('description')}
        />);
        const mainButtonLabel = formatText('hireAdvancedInterstitialPromotionSuccess-hireAdvancedInterstitialPromotionSuccess_backButtonLabel');
        const successMessage = formatText('hireAdvancedInterstitialPromotionSuccess-hireAdvancedInterstitialPromotionSuccess_detailTitle');
        const mainButton = {
            label: mainButtonLabel,
            url: '/myprofile/edit'
        };

        return (
            <section className="col-xs-offset-2 col-xs-8 hire-adv-interstitial-promotion-success">
                <WizardSuccess
                    mainButton={mainButton}
                    successMessage={successMessage}
                >
                    <div className="hire-adv-interstitial-promotion-success__caption">
                        <div className="hire-adv-interstitial-promotion-success__caption-detail">
                            {promotionDetail}
                        </div>
                    </div>
                </WizardSuccess>
            </section>
        );
    }
}

HireAdvInterstitialPromotionSuccess.propTypes = {
    immAdvancedInterstitialPromotions: PropTypes.object.isRequired,
    getAdvancedInterstitialPromotions: PropTypes.func.isRequired
};

module.exports = HireAdvInterstitialPromotionSuccess;